export const Offers = [
  {
    _id: 0,
    nameKey: "Up to 15% OFF",
    array: [0, 15],
  },
  {
    _id: 1,
    nameKey: "Up to 30% OFF",
    array: [15, 30],
  },
  {
    _id: 2,
    nameKey: "Up to 45% OFF",
    array: [30, 45],
  },
  {
    _id: 3,
    nameKey: "Up to 60% OFF",
    array: [45, 60],
  },
  {
    _id: 4,
    nameKey: "60% and Above OFF",
    array: [60, 100],
  },
];
